import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Address from '../../common/Address';
import Subject from './Subject';
import { t } from '../../../modules/infra/i18n';

const EmailPreview = ({ backgroundImage, color, logo, shopAddress, shopName, subject, children, onSubjectClick }) => (
  <div>
    <h3 className="c-heading c-heading--tiny u-mb-">{t('engage:sections.email_preview')}</h3>
    <div className="c-email-preview">
      <div className="c-email-preview__titlebar" />
      <div className="c-email-preview__subject">
        <span className="u-type--semibold">{t('engage:email_preview.to_label')}</span>john@example.com
      </div>
      <div
        className={classnames('c-input c-input--white u-type--semibold u-mb', {
          'c-input--danger': !subject,
        })}
      >
        <Subject defaultText={t('engage:email_preview.add_subject')} value={subject} onClick={onSubjectClick} />
      </div>
      <div
        className={classnames('c-email-preview__header', { 'c-email-preview__header--image': backgroundImage })}
        style={{ backgroundColor: color, backgroundImage: `url(${backgroundImage})` }}
      >
        <div display-if={logo && backgroundImage} className="c-email-preview__header--image-tint" />
        <div className="u-mb">
          <img src={logo} alt="" className="c-logo" display-if={logo} />
        </div>
        <div display-if={logo}>{shopName}</div>
      </div>
      <div className="c-email-preview__body">{children}</div>
      <div className="c-email-preview__footer">
        <div className="u-type--semibold">{shopName}</div>
        <div>
          <Address address={shopAddress} />
        </div>
      </div>
    </div>
  </div>
);
EmailPreview.propTypes = {
  shopAddress: PropTypes.shape({
    street: PropTypes.string,
    street2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }).isRequired,
  shopName: PropTypes.string.isRequired,
  subject: PropTypes.string,
  children: PropTypes.node.isRequired,
  backgroundImage: PropTypes.string,
  color: PropTypes.string,
  logo: PropTypes.string,
  onSubjectClick: PropTypes.func.isRequired,
};
EmailPreview.defaultProps = {
  backgroundImage: '',
  color: '#4d4d4d',
  logo: '',
  editable: true,
  subject: '',
};

export default EmailPreview;
